import React from "react";
import useSmartviewManager from "../hooks/use-smartview-manager";

export default function WhenCanGoBack(props) {

    const smartviewManager = useSmartviewManager();

    if (!smartviewManager.canGoBack()) {
        return null;
    }

    return props.children;
}
